import * as React from 'react';
import Grid from '@mui/system/Unstable_Grid';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import image from '../../image/contact.svg'

export default function Form({resize}) {
  const button = {
    width: '100%',
    display: 'flex',
    justifyContent: 'end',
    padding: '50px 0px 70px 0px'
  }

  const [errorMessage, setErrorMessage] = React.useState({
    name:'',
    email: '',
    subject: '',
    message: ''
  })

  const style_image = {
    width: (resize)?'300px': "200px",
    height:(resize)?'300px': "200px"
  }
  const [value, setValue] = React.useState({
    name:'',
    email: '',
    subject: '',
    message: ''
  })



  const [empty, setEmpty] = React.useState({
    name:false,
    email: false,
    subject: false,
    message: false
  })

  const handleSubmit = (e) => {
    e.preventDefault()
    if(!value.name){
      setEmpty((old) => {
        return {...old, name: true}
      })
      setErrorMessage((preverror) => {
        return {...preverror, name: 'This field is required'}
      })
    }
    if(!value.email){
      setEmpty((old) => {
        return {...old, email: true}
      })

      setErrorMessage((preverror) => {
        return {...preverror, email: 'This field is required'}
      })
    }
    if(!value.subject){
      setEmpty((old) => {
        return {...old, subject: true}
      })

      setErrorMessage((preverror) => {
        return {...preverror, subject: 'This field is required'}
      })
    }
    if(!value.message){
      setEmpty((old) => {
        return {...old, message: true}
      })
      setErrorMessage((preverror) => {
        return {...preverror, message: 'This field is required'}
      })
    }
    // this is where data gathered
    // this is very important place ....................................................................................................................
    if(value.name && value.email && value.subject && value.message){
      console.log(value)    }
  }


  const handleName = (n) => {
      if(empty.name){
         setEmpty((old) => {
        return {...old, name: false}
      })

      setErrorMessage((preverror) => {
        return {...preverror, name: ''}
      })
      }
     
      setValue((oldName) => {
      return {...oldName, name: n.target.value}
    })
  }

  const handleEmail = (e) =>{
    const eml = e.target.value
    if((!eml.includes("@") | !eml.includes(".")) && eml ){
      setEmpty((old) => {
        return {...old, email: true}
      })

      setErrorMessage((preverror) => {
        return {...preverror, email: 'Please enter a valid email'}
      })
    }else{
      setEmpty((old) => {
      return {...old, email: false}
    })

    setErrorMessage((preverror) => {
      return {...preverror, email: ''}
    })
    }

    
    setValue((oldName) => {
      return {...oldName, email: eml}
    })
  }

  const handleSubject = (s) => {
    if(empty.subject){
        setEmpty((old) => {
        return {...old, subject: false}
      })

      setErrorMessage((preverror) => {
        return {...preverror, subject: ''}
      })}

      setValue((oldName) => {
      return {...oldName, subject: s.target.value}
    })
  }

  const handleMessage = (m) =>{
    if(empty.message){
      setEmpty((old) => {
      return {...old, message: false}
    })

    setErrorMessage((preverror) => {
      return {...preverror, message: ''}
    })
    }
    

    setValue((oldName) => {
      return {...oldName, 'message': m.target.value}
    })
  }

  return (
<Grid container spacing={2} justifyContent={'center'} direction={'column'} alignItems={'center'}>
    <Grid >
      <div>
        <img src={image} alt="contact" style={style_image}/>
      </div>
    </Grid>
    <Grid style={{width: '70%'}}>
          <form noValidate autoComplete="off" style={{width: '100%'}} onSubmit={handleSubmit}> 
                    <TextField
                        name = 'name'
                        margin='normal'
                        error={empty.name}
                        value={value.name}
                        onChange={handleName}  
                        fullWidth
                        required
                        id="name"
                        label="name"
                        variant="standard"
                        helperText={errorMessage.name}
                     />
                    <TextField
                      name='email'
                      value={value.email}
                      onChange={handleEmail}
                      error={empty.email}
                      type='email'
                      margin='normal'
                      fullWidth
                      required
                      id="email"
                      label="email"
                      variant="standard"
                      helperText={errorMessage.email}
                    />
                
                  <TextField
                      name='subject'
                      value={value.subject}
                      onChange={handleSubject}
                      error={empty.subject}
                      margin='normal'
                      fullWidth
                      required
                      id="subject"
                      label=" subject"
                      variant="standard"
                      helperText={errorMessage.subject}
                    />
                
                  <TextField
                      name='message'
                      value={value.message}
                      onChange={handleMessage}
                      error={empty.message}
                      margin='normal'
                      fullWidth
                      required
                      id="message"
                      label=" message"
                      variant="standard"
                      multiline
                      maxRows={4}
                      helperText={errorMessage.message}
                  />
                <div style={button}>
                <Button variant="contained" type="submit" >Let's go</Button>    
                </div>

              

          </form>
    </Grid>
  </Grid>
  
);
}
